import { dialogAllocateInfoErrorType } from '@/constants';
import { orderService } from '@/services';
import { i18n } from '@/locales';
import { getTitle, getMessage, } from '@/lib/map-control/allocateAlertPopup';
import { ServiceDataOrderEvent } from '@/service-data/order-event/ServiceDataOrderEvent';
import { vuexEventPathGenerator } from '@/utils';
import { allocateWorkerType } from '@/constants/global';
import { BusinessError } from '@/error';
import { mutationType } from './mutations';
export const actionType = {
    allocateEvent: 'allocateEvent',
    setOrderList: 'setOrderList',
    setWorker: 'setWorker',
    setOnCloseAction: 'setOnCloseAction',
};
export const allocationControllerActionType = vuexEventPathGenerator(actionType, 'allocationController');
const lc = 'views.map_control.dialog_allocation_alert.';
const action = {
    [actionType.setOnCloseAction]({ commit }, payload) {
        commit(mutationType.SET_ON_CLOSE_ACTION, payload);
    },
    [actionType.setWorker]({ commit }, payload) {
        commit(mutationType.SET_WORKER, payload);
    },
    [actionType.setOrderList]({ commit }, payload) {
        commit(mutationType.SET_ORDER_LIST, payload);
    },
    /**
     * 배요, 즉배, 재배
     * @param payload
     * @param payload.workerCode
     * @param payload.orderIds 주문 아이디 리스트
     * @returns promise all 리턴 배열
     */
    async [actionType.allocateEvent]({ 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state, }, { workerCode, orderList, allocateWorkerType: _allocateWorkerType, }) {
        let allocatedEvent;
        switch (_allocateWorkerType) {
            case allocateWorkerType.REALLOCATE:
                allocatedEvent = orderService.reallocate;
                break;
            case allocateWorkerType.IMMEDIATE:
                allocatedEvent = orderService.allocate;
                break;
            case allocateWorkerType.REQUEST_ALLOCATE:
                allocatedEvent = orderService.workerRequest;
                break;
            default:
        }
        const result = await Promise.all(orderList.map(async (order) => {
            const { orderId, orderAgencyId, orderAgencyOptions, storeName, } = order;
            let { allocatedWorkerName, } = order;
            try {
                const serviceData = new ServiceDataOrderEvent({
                    orderId,
                    workerCode,
                });
                serviceData.setOrderEvent(_allocateWorkerType);
                const allocatedResult = await allocatedEvent(serviceData);
                return {
                    isSuccess: true,
                    title: i18n.t(`${lc}${getTitle('success', _allocateWorkerType)}`),
                    workerName: allocatedWorkerName,
                    storeName,
                    orderId,
                    message: getMessage(_allocateWorkerType, orderAgencyOptions),
                    orerAgencyId: orderAgencyId,
                    result: allocatedResult,
                };
            }
            catch (error) {
                if (error instanceof BusinessError && error?.reason === dialogAllocateInfoErrorType.DENY_ORDER) {
                    allocatedWorkerName = null;
                }
                if (error instanceof BusinessError) {
                    return {
                        isError: true,
                        title: i18n.t(`${lc}${getTitle('error', _allocateWorkerType)}`),
                        storeName,
                        orderId,
                        workerName: allocatedWorkerName,
                        message: error.message,
                        reason: error.reason,
                    };
                }
                return {
                    isError: true,
                    title: i18n.t(`${lc}${getTitle('error', _allocateWorkerType)}`),
                    storeName,
                    orderId,
                    workerName: allocatedWorkerName,
                    message: error.data.error.message,
                    reason: error.data.error.reason || error.data.error.message,
                };
            }
        }));
        return result;
    },
};
export default action;
